<template>
  <div>
    <div class="top-spacing"></div>
    <div class="banner-container">
      <img class="banner-image" src="@/images/cacban2.png" alt="系统对接横幅" />
    </div>
    <div class="title-section">
      <h1>系统对接</h1>
      <div class="horizontal-line"></div>
    </div>
    <ul class="platform-list">
      <li v-for="(item, index) in platformCont" :key="index" class="platform-item">
        <div class="item-title">{{ item.title }}</div>
        <div class="item-icon-container">
          <div v-for="(icon, iconIndex) in item.Ico" :key="iconIndex" class="icon-wrapper">
            <img class="platform-icon" :src="icon" alt="" />
          </div>
        </div>
      </li>
      <li v-for="(item, index) in erp" :key="index" class="platform-item">
        <div class="item-title">{{ item.title }}</div>
        <div class="item-icon-container">
          <div v-for="(icon, iconIndex) in item.Ico" :key="iconIndex" class="icon-wrapper-erp">
            <img class="platform-icon-erp" :src="icon" alt="" />
          </div>
        </div>
      </li>
      <li v-for="(item, index) in express" :key="index" class="platform-item">
        <div class="item-title">{{ item.title }}</div>
        <div class="item-icon-container">
          <div v-for="(icon, iconIndex) in item.Ico" :key="iconIndex" class="icon-wrapper-express">
            <img class="platform-icon-express" :src="icon" alt="" />
          </div>
        </div>
      </li>
    </ul>
    <img class="bottom-image" src="@/images/1752637889895.png" alt="底部装饰" />
    <img class="center-image" src="@/images/cacpen.png" alt="中心展示图" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      platformCont: [
        {
          title: "平台",
          Ico: [
            require("@/images/xtdj01.png"),
            require("@/images/xtdj02.png"),
            require("@/images/xtdj03.png"),
            require("@/images/xtdj04.png"),
            require("@/images/xtdj05.png"),
            require("@/images/xtdj06.png")
          ]
        }
      ],
      erp: [
        {
          title: "ERP",
          Ico: [
            require("@/images/xtdj07.png"),
            require("@/images/xtdj08.png"),
            require("@/images/xtdj09.png"),
            require("@/images/xtdj10.png"),
            require("@/images/xtdj11.png"),
            require("@/images/xtdj12.png")
          ]
        }
      ],
      express: [
        {
          title: "快递",
          Ico: [
            require("@/images/xtdj13.png"),
            require("@/images/xtdj14.png"),
            require("@/images/xtdj15.png"),
            require("@/images/xtdj16.png"),
            require("@/images/xtdj17.png"),
            require("@/images/xtdj18.png"),
            require("@/images/xtdj19.png"),
            require("@/images/xtdj20.png"),
            require("@/images/xtdj21.png")
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.top-spacing {
  height: 80px;
}

.banner-container {
  width: 100%;
}

.banner-image {
  width: 100%;
}

.title-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.horizontal-line {
  background-color: rgb(0, 0, 0);
  width: 50px;
  height: 6px;
  border-radius: 10px;
}

.platform-list {
  display: flex;
  list-style-type: none;
  margin: 40px 0;
  padding: 0;
  justify-content: center;
  flex-wrap: wrap;
}

.platform-item {
  width: 405px;
  height: 260px;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin: 20px;
}

.item-title {
  background: url(@/images/xttopbg.png) no-repeat;
  width: 100%;
  height: 18%;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-icon-container {
  height: 82%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.icon-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  height: 53px;
  margin: 0 30px;
}

.platform-icon {
  width: auto;
  height: auto;
}

.icon-wrapper-erp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.platform-icon-erp {
  width: auto;
  height: auto;
  border: 1px solid #ccc;
}

.icon-wrapper-express {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  height: 53px;
  margin: 0 10px;
}

.bottom-image {
  width: 100%;
}

.center-image {
  display: block;
  width: 1219px;
  height: 537px;
  margin: 20px auto;
}

@media (max-width: 768px) {
  .platform-list {
    flex-direction: column;
    align-items: center;
  }
  
  .platform-item {
    margin: 20px 0;
    width: 90%;
    max-width: 405px;
  }
  
  .center-image {
    width: 100%;
    height: auto;
    max-width: 1219px;
  }
}
</style>  